<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
          <div class="help_page global__scrollcustom">
            <div class="container-fluid p-0">
              <div class="row justify-content-between __pathlist2_ pl-0 __wrapper_ pb-3">
                <!-- <p class="__path">Help</p> -->
              </div>
              <div class="__mastercontent d-flex flex-column text-left">
                <form  @submit.prevent="handleSubmit" class="__formSignin" action="" method="">
                  <p class="__title"> <b>Having Trouble? <br> We Are Ready to Help</b></p>
                  <div class="__customdropdown_dst2">
                    <p class="__subtitle"> <b>Enquiry Type</b></p>
                    <b-input-group>
                      <b-dropdown right>
                        <template slot="button-content">
                          <p>{{ subject }}</p>
                        </template>
                        <b-dropdown-item
                          v-for="gender in optionType"
                          v-on:click="selectedOption(gender)"
                          :key="gender.value">
                          <span>{{ gender.text }}</span>
                        </b-dropdown-item>
                      </b-dropdown>
                      <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                    </b-input-group>
                  </div>
                  <p class="__subtitle"> <b>Subject</b> </p>
                  <b-form-input v-model="form.subjectDescription" v-validate="'required'" name="subjectDescription" class="mb-2" type="text" placeholder="Enter Subject Description" />
                  <p class="__subtitle"> <b>Message</b></p>
                  <b-form-textarea
                  class="mb-2"
                  id="textarea"
                  placeholder="Enter Your Message"
                  rows="3"
                  max-rows="5"
                  v-model="form.message"
                  />
                  <div class="text-right">
                     <button class="__btnActive __btnActive_navy" type="submit">Submit</button>
                  </div>
                </form>
             </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'help',
  components: {
    Sidebar
  },
  data () {
    return {
      optionType: [
        { text: 'Having trouble while registering account', value: 'Having trouble while registering account' },
        { text: 'Cannot log into my account', value: 'Cannot log into my account' },
        { text: 'Password recovery doesnt work', value: 'Password recovery doesnt work' },
        { text: 'Cannot invite new user', value: 'Cannot invite new user' },
        { text: 'Cannot find quote from any routes', value: 'Cannot find quote from any routes' },
        { text: 'Others', value: 'Others' }
      ],
      subject: 'Having trouble while registering account',
      form: {
        subject: 'Having trouble while registering account',
        fullname: '',
        email: '',
        phone: '',
        sender: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      items: 'contact/items',
      isLoading: 'contact/isLoading',
      isError: 'contact/error'
    })
  },
  methods: {
    submitmsg: function () {
      this.$eventHub.$emit('dialog-help-submit')
    },
    selectedOption: function (params) {
      this.subject = params.text
      this.form.subject = params.value
    },
    handleSubmit (e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const payload = this.form
          this.$store.dispatch('contact/POST_HELP', payload)
        } else {
          alert('Correct them errors!')
        }
      })
    }
  },
  watch: {
    items (data) {
      if (data) {
        this.$eventHub.$emit('dialog-help-submit')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/help/index.vue